// src/hooks/useErrorHandler.js
import { useState } from 'react';
import { logError } from '../services/errorService';

/**
 * Custom hook for standardized error handling across components
 * @returns {Object} Error state and handler functions
 */
export const useErrorHandler = () => {
  const [error, setError] = useState(null);
  
  /**
   * Handles errors uniformly across the application
   * @param {Error} error - The error object
   * @param {Object} context - Additional context about where/how the error occurred
   * @returns {string} User-friendly error message
   */
  const handleError = (error, context = {}) => {
    const errorMessage = logError(error, context);
    setError(errorMessage);
    return errorMessage;
  };
  
  /**
   * Clears the current error state
   */
  const clearError = () => setError(null);
  
  return { error, handleError, clearError };
};

export default useErrorHandler;
